import React from "react";
import { useTranslation } from "react-i18next";

// Components
import WebinarList from "pages/ticketing/components/WebinarList";

function Webinars() {
  const { t } = useTranslation();

  return (
    <div>
      <section>
        <div className="space-y-4 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-orange app-animation-translate-start">
            {t("webinarListTitle")}
          </p>
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start">
            {t("webinarListSubTitle")}
          </p>

          <WebinarList />
        </div>
      </section>
    </div>
  );
}

export default Webinars;
